import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import CarouselNavArrow from "@components/Icons/CarouselNavArrow";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

const HomepageSlider = ({ items, autoplay = false }) => {
  const [prevEl, setPrevEl] = useState(null);
  const [nextEl, setNextEl] = useState(null);

  // Brico: the banner sits flush under the header, so keep its top square and
  // round only the bottom edge. Using `rounded-b-2xl` (an edge class) instead
  // of the diagonal `rounded-bl-2xl` avoids the centralized brico rounding CSS,
  // which would otherwise round the top corners too. Altex/MG keep the diagonal.
  const sliderRadius =
    settings.websiteName === "bricostore"
      ? "lg:rounded-b-2xl"
      : "lg:rounded-bl-2xl";

  // TODO this function should be moved to "@lib/GTMHelper"
  const trackBannerView = (index) => {
    const currentBanner = items[index];
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

    window.dataLayer.push({
      event: "view_promotion",
      ecommerce: {
        promotion_name: `${settings.websiteName.toUpperCase()} - HOMEPAGE`,
        creative_name: currentBanner?.link,
        creative_slot: index,
      },
    });
  };

  // TODO this function should be moved to "@lib/GTMHelper"
  const trackBannerClick = (banner, index) => {
    window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

    const creativeName = banner.link?.startsWith("http")
      ? new URL(banner.link).pathname
      : banner.link;

    window.dataLayer.push({
      event: "select_promotion",
      ecommerce: {
        promotion_name: `${settings.websiteName.toUpperCase()} - HOMEPAGE`,
        creative_name: creativeName,
        creative_slot: index,
      },
    });
  };

  return (
    <div className="container px-0 lg:px-15px">
      <div className="md:mb-4">
        {items && items.length ? (
          <div className="relative">
            <Swiper
              className={`${sliderRadius} bg-red-brand`}
              slidesPerView={1}
              spaceBetween={0}
              onSlideChange={(props) => {
                trackBannerView(props.realIndex);
              }}
              loop={true}
              pagination={{
                clickable: true,
              }}
              autoHeight={true}
              autoplay={
                autoplay
                  ? {
                      delay: 3500,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }
                  : false
              }
              navigation={{
                nextEl,
                prevEl,
              }}
              modules={[Autoplay, Pagination, Navigation]}
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  {/* TODO: Use Link for internal links, anchors for external */}
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackBannerClick(item, index)}
                  >
                    <img
                      src={`${settings.cdn}${item.file}`}
                      alt=""
                      className="mx-auto"
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="hidden md:flex absolute top-0 left-0 ml-8 h-full items-center ">
              <div
                className="w-7 h-7 lg:w-10 lg:h-10 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10"
                ref={(node) => setPrevEl(node)}
              >
                <CarouselNavArrow direction="left" />
              </div>
            </div>

            <div className="hidden md:flex absolute top-0 right-0 mr-8 h-full items-center">
              <div
                className="w-7 h-7 lg:w-10 lg:h-10 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10"
                ref={(node) => setNextEl(node)}
              >
                <CarouselNavArrow direction="right" />
              </div>
            </div>
          </div>
        ) : (
          <img
            src={`${settings.websiteStatics}/images/empty-home-banner.jpg`}
            alt=""
          />
        )}
      </div>
    </div>
  );
};

export default HomepageSlider;
